import { useState } from 'react';
import { SectionCard } from './section-card';
import { useAuth } from '@/hooks/use-auth';
import { changePassword } from '@/lib/settings-api';

export function PasswordSection() {
  const { accessToken, signOut } = useAuth();
  const [oldPw, setOldPw] = useState('');
  const [newPw, setNewPw] = useState('');
  const [confirm, setConfirm] = useState('');
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function handleSubmit() {
    setError('');
    setMsg('');
    if (newPw.length < 8) {
      setError('Neues Passwort muss mindestens 8 Zeichen haben.');
      return;
    }
    if (newPw !== confirm) {
      setError('Die neuen Passwörter stimmen nicht überein.');
      return;
    }
    if (!accessToken) {
      setError('Nicht eingeloggt.');
      return;
    }
    setBusy(true);
    try {
      await changePassword(accessToken, oldPw, newPw);
      setMsg('Passwort geändert. Bitte melde dich mit dem neuen Passwort neu an.');
      setOldPw('');
      setNewPw('');
      setConfirm('');
      setTimeout(() => {
        signOut();
        window.location.href = '/';
      }, 1500);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Passwort-Änderung fehlgeschlagen');
      setBusy(false);
    }
  }

  return (
    <SectionCard title="Passwort" description="Ändere dein Login-Passwort.">
      <label className="block text-sm text-slate-300">
        Aktuelles Passwort
        <input
          type="password"
          autoComplete="current-password"
          value={oldPw}
          onChange={(e) => setOldPw(e.target.value)}
          className="mt-1 w-full rounded-lg border border-slate-700 bg-slate-950/60 px-3 py-2 text-slate-100"
        />
      </label>
      <label className="block text-sm text-slate-300">
        Neues Passwort
        <input
          type="password"
          autoComplete="new-password"
          value={newPw}
          onChange={(e) => setNewPw(e.target.value)}
          className="mt-1 w-full rounded-lg border border-slate-700 bg-slate-950/60 px-3 py-2 text-slate-100"
        />
      </label>
      <label className="block text-sm text-slate-300">
        Neues Passwort wiederholen
        <input
          type="password"
          autoComplete="new-password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          className="mt-1 w-full rounded-lg border border-slate-700 bg-slate-950/60 px-3 py-2 text-slate-100"
        />
      </label>
      {error ? <p className="text-sm text-red-400">{error}</p> : null}
      {msg ? <p className="text-sm text-emerald-400">{msg}</p> : null}
      <button
        type="button"
        onClick={handleSubmit}
        disabled={busy}
        className="rounded-lg bg-amber-500 px-4 py-2 text-sm font-semibold text-slate-950 hover:bg-amber-400 disabled:opacity-50"
      >
        Passwort ändern
      </button>
    </SectionCard>
  );
}
